import { cn } from '@/lib/utils';
import { submissionStatusLabel, submissionStatusTone } from '@/lib/submissions';
import type { SubmissionStatus } from '@/services/types';

interface SubmissionStatusBadgeProps {
  status: SubmissionStatus;
}

const toneClass = {
  processing: 'bg-blue-50 text-blue-700',
  success: 'bg-green-50 text-green-700',
  failure: 'bg-red-50 text-red-600',
};

export default function SubmissionStatusBadge({ status }: SubmissionStatusBadgeProps) {
  const tone = submissionStatusTone(status);

  return (
    <span className={cn('inline-flex items-center px-2.5 py-1 rounded-full text-[0.75rem] font-medium', toneClass[tone])}>
      {submissionStatusLabel(status)}
    </span>
  );
}
